import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { DeliveryAuthProvider, useDeliveryAuth } from './context/DeliveryAuthContext';
import DeliveryLogin from './pages/DeliveryLogin';
import DeliveryDashboard from './pages/DeliveryDashboard';
import ActiveDelivery from './pages/ActiveDelivery';
import DeliveryHistory from './pages/DeliveryHistory';
import DeliveryProfile from './pages/DeliveryProfile';
import './DeliveryApp.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useDeliveryAuth();

  if (loading) {
    return (
      <div className="delivery-loading">
        <div className="delivery-loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return currentUser ? children : <Navigate to="/delivery/login" replace />;
};

// Main Delivery App Routes
const DeliveryRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<DeliveryLogin />} />
      <Route
        path="dashboard"
        element={
          <ProtectedRoute>
            <DeliveryDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="active"
        element={
          <ProtectedRoute>
            <ActiveDelivery />
          </ProtectedRoute>
        }
      />
      <Route
        path="history"
        element={
          <ProtectedRoute>
            <DeliveryHistory />
          </ProtectedRoute>
        }
      />
      <Route
        path="profile"
        element={
          <ProtectedRoute>
            <DeliveryProfile />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/delivery/dashboard" replace />} />
    </Routes>
  );
};

// Delivery App Wrapper
const DeliveryApp = () => {
  return (
    <DeliveryAuthProvider>
      <div className="delivery-app">
        <DeliveryRoutes />
      </div>
    </DeliveryAuthProvider>
  );
};

export default DeliveryApp;
